import React from "react";

import { useDeleteAlertRule } from "api/api-hooks/alert-rules-hooks";
import { AlertRuleDTO } from "api/model/alerts/alert-types";
import ActionButtons from "components/basic/action-buttons/ActionButtons";

type RuleActionsProps = {
  rule: AlertRuleDTO;
  onEdit: (rule: AlertRuleDTO) => void;
};

const RuleActions: React.FC<RuleActionsProps> = ({ rule, onEdit }) => {
  const { mutate: deleteRule, isPending } = useDeleteAlertRule();

  return (
    <ActionButtons
      onClickEdit={() => onEdit(rule)}
      onClickDelete={() => deleteRule(rule.id)}
      loadingDelete={isPending}
    />
  );
};

export default RuleActions;
